import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import {
  Box,
  Button,
  Card,
  Grid,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { getCourtTypes } from "services/courtTypeServices";
import CourtTypeFilter from "./courtTypeFilter";

function CourtTypes() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, [filter]);

  const loadData = async () => {
    setLoading(true);
    const { data, error } = await getCourtTypes({
      queryParams: filter || "",
    });

    if (error) { console.log(error) }
    if (data) {
      setRows(data)
    }
  
    setLoading(false);
  };  

  return (
    <>
      <Grid container xs={12}>
        <Grid item xs={3}>
          <Button
            variant="contained"
            disableElevation
            onClick={() => navigate("/court-types/add")}
          >
            Add New Court Type
          </Button>
        </Grid>
        <Grid item xs>
          <CourtTypeFilter filter={filter} onChangeFilter={setFilter} />
        </Grid>
      </Grid>

      <Card sx={{ mb: 3 }}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                                {/* <TableCell>Type</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.length > 0 && rows.map((row) => (
                                <TableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell scope="row">
                                        <span className='span-link' onClick={() => {
                                            navigate(`/court-types/edit/${row._id}`)
                                        }}>{row.name}</span></TableCell>
                                    {/* <TableCell scope="row">{row.address}</TableCell> */}
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
    </>
  );
}

export default CourtTypes;
